package com.klantenstop.web.pages.settings

import com.klantenstop.web.utils.MVI
import com.materialkobweb.utils.ViewModel
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class SettingsViewModel(
    colorMode: ColorMode,
) : ViewModel(), MVI<SettingsContract.State, SettingsContract.Intent, SettingsContract.Effect> {

    private val _state = MutableStateFlow(
        SettingsContract.State(currentColorMode = colorMode)
    )
    override val state = _state

    private val _effect = MutableSharedFlow<SettingsContract.Effect>()
    override val effect = _effect

    override fun sendIntent(intent: SettingsContract.Intent) = coroutineScope.launch {
        when (intent) {
            is SettingsContract.Intent.UpdateHoveringColorMode -> updateState { it.copy(hoveringColorMode = intent.colorMode) }
            is SettingsContract.Intent.SelectColorMode -> {
                updateState { it.copy(currentColorMode = intent.colorMode, hoveringColorMode = intent.colorMode) }
                emitEffect(SettingsContract.Effect.SelectColorMode(intent.colorMode))
            }


            is SettingsContract.Intent.ManageConsent -> emitEffect(SettingsContract.Effect.OpenConsentModal)
        }
    }

    override fun emitEffect(effect: SettingsContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (SettingsContract.State) -> SettingsContract.State) {
        _state.update(block)
    }
}
